<template>
  <div class="main-container">
    <!-- <div class="notincluded">
            <span> Development will be done in the next Version </span>
        </div> -->
    <!-- <breadcrumb main_step_name="Overview" step_name="Feed" @goToMainStep="goToOverview" /> -->

    <div class="row">
      <div class="col-8">
        <div v-show="!ifEmployee">
          <div class="chatRect-2">
            <div class="headerClass">
              <div class="row">
                <div class="col-1">
                  <img class="img-post-user" src="@/assets/user.svg" />
                </div>
                <div class="col-11" @click="addAnnouncement()">
                  <div class="post-question">
                    What's today special?
                  </div>
                </div>
              </div>
              <hr class="mt-3" />
              <div class="row">
                <div class="col-12">
                  <div class="my-3 float-right">
                    <!-- <span
                      class="post-block-image mr-3"
                      style="cursor: pointer"
                      @click="addAnnouncement('video')"
                    >
                      <img class="celebrate-icon" src="@/assets/feed_Gif.svg" />
                      Video
                    </span> -->
                    <span
                      class="post-block-image ml-2"
                      style="cursor: pointer"
                      @click="addAnnouncement('image')"
                    >
                      <img
                        class="celebrate-icon"
                        src="@/assets/feed_gallery.svg"
                      />
                      Photo/GIF
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="headerClass">
            <tl-header type="h1">
              <div class="main-header">Announcements</div>
            </tl-header>
          </div>

          <v-container>
            <v-timeline dense>
              <v-timeline-item
                v-for="(post, index) in postList"
                :key="index"
                color="#55cac8"
                right
                samll
              >
                <span slot="opposite">Tus eu perfecto</span>
                <v-card class="elevation-2">
                  <v-card-title class="headline">
                    <span class="post-name-block" @click="displayDetails(post)">{{
                      post.name
                    }}</span>
                    <img
                      class="pin-blue"
                      style="cursor: pointer"
                      v-if="index > 0"
                      src="@/assets/feed_pin.svg"
                      alt
                      @click="pinPost(index)"
                    />
                    <img
                      class="pin-blue"
                      v-if="index === 0"
                      src="@/assets/feed_pin2.svg"
                      alt
                    />
                    <div class="post-time">{{ formatDate(post.created_at) }}</div>
                  </v-card-title>
                  <v-card-text>
                    {{ post.details }}
                  </v-card-text>
                  <div v-if="post.filePath && post.filePath.length > 0">
                    <div class="row">
                      <div class="col-2"></div>
                      <div class="col-8 px-2 py-2">
                        <v-carousel hide-delimiters show-arrows interval="6000" v-if="post.fileType !== 'video/mp4'">
                          <v-carousel-item
                            v-for="(item, i) in post.filePath"
                            :key="i"
                            :src="item"
                            reverse-transition="fade-transition"
                            transition="fade-transition"
                          ></v-carousel-item>
                        </v-carousel>
                        <div v-else>
                          <video v-for="(item, i) in post.filePath" :key="i" width="100%" height="100%" controls autoplay>
                            <source :src="item" type="video/mp4" />
                            <source src="movie.ogg" type="video/ogg" />
                            Your browser does not support the video tag.
                          </video>
                        </div>
                      </div>
                      <div class="col-2"></div>
                    </div>
                  </div>
                </v-card>
              </v-timeline-item>
            </v-timeline>
          </v-container>
        </div>
      </div>
      <div class="col-4">
        <div class="chatRect">
          <div class="headerClass">
            <tl-header type="h1">
              <div class="main-header">My Approval Requests</div>
            </tl-header>
            <!-- <span class="digit-12">12</span>
            <span class="update-text">Update Requests Sent</span> -->
          </div>
        </div>
        <!-- <div
          class="chatRect my-4"
          @click="bdayAnnavarsary"
        >
          <div class="headerClass">
            <tl-header type="h1">
              <div class="main-header">Birthday & Anniversaries</div>
            </tl-header>
            <div class="avatars">
              <span class="avatar">
                <img src="@/assets/user.svg" width="50" height="50" />
              </span>
              <span class="avatar">
                <img src="@/assets/user.svg" width="50" height="50" />
              </span>
              <span class="avatar">
                <img src="@/assets/user.svg" width="50" height="50" />
              </span>
              <span class="avatar">
                <img src="@/assets/user.svg" width="50" height="50" />
              </span>
              <span class="avatar">
                <img src="@/assets/user.svg" width="50" height="50" />
              </span>
            </div>
            <div class="celebrate-section mt-3">
              <p>
                <img class="celebrate-icon" src="@/assets/feed_cake.svg" />
                <strong>Gaurav Dixit</strong> and 14 others
              </p>
              <p>
                <img class="celebrate-icon" src="@/assets/feed_confetti.svg" />
                <strong>Abhishek Rana</strong> and 18 others
              </p>
              <p>
                <img class="celebrate-icon" src="@/assets/feed_ring.svg" />
                <strong>Arvind Kejriwal</strong> and 34 others
              </p>
            </div>
          </div>
        </div> -->
        <div class="chatRect my-4">
          <div class="headerClass">
            <tl-header type="h1">
              <div class="main-header">Manage</div>
            </tl-header>
            <div class="mb-3 mt-2">
              <div class="manage-text cursor-pointer-show" @click="goToITDeclaration(employeeId)">IT Declaration</div>
              <!-- <div class="icon-arrow" style="cursor: pointer">
                <img src="@/assets/next-icon.png" alt />
              </div> -->
            </div>
            <div class="mb-3 mt-2">
              <div class="manage-text cursor-pointer-show" @click="goToITProofSubmission(employeeId)">IT Proof Submission</div>
              <!-- <div class="icon-arrow" style="cursor: pointer">
                <img src="@/assets/next-icon.png" alt />
              </div> -->
            </div>
            <!-- <div class="mb-3">
              <div class="manage-text">FBP Declaration</div>
              <div class="icon-arrow" style="cursor: pointer">
                <img src="@/assets/next-icon.png" alt />
              </div>
            </div>
            <div class="mb-3">
              <div class="manage-text">FBP Claims</div>
              <div class="icon-arrow" style="cursor: pointer">
                <img src="@/assets/next-icon.png" alt />
              </div>
            </div> -->
            <!-- <div class="mb-3">
              <div class="manage-text cursor-pointer-show" @click="goToMyDocuments">My Documents</div> -->
              <!-- <div class="icon-arrow" style="cursor: pointer">
                <img src="@/assets/next-icon.png" alt />
              </div> -->
            <!-- </div> -->
          </div>
        </div>
      </div>
    </div>

    <!-- Add Announcement Modal -->
    <div class="modal" v-if="showConfirmationMsg">
      <div class="modal-content" ref="modalBox">
        <div class="custom-top-bar">
          <span class="heading_new">Add Announcement</span>
        </div>
        <hr class="custom-line" />
        <div class="row">
          <div class="col-1">
            <img class="img-post-user" src="@/assets/user.svg" />
          </div>
          <div class="col-10">
            <div class="post-user-name">Moni Hampton</div>
          </div>
        </div>
        <div class="row my-2">
          <div class="col-12">
            <textarea
              class="form-control custom-textarea"
              rows="2"
              name="title"
              v-model="postform.annoucement"
              placeholder="Here is post title"
            />
          </div>
        </div>
        <div class="row my-2">
          <div class="col-12">
            <textarea
              class="form-control custom-textarea"
              rows="5"
              name="description"
              v-model="postform.details"
              placeholder="Here is post desciption"
            />
          </div>
        </div>
        <!-- <ckeditor :editor="editor" :config="editorConfig"></ckeditor> -->

        <!-- <input type="file" @change="onFileChange" />

        <div id="preview">
          <img v-if="url" :src="url" />
        </div> -->

        <input
          type="file"
          multiple
          accept="image/jpeg"
          @change="uploadImage"
          style="display: none"
          ref="fileInput"
        />

        <!-- <input
          type="file"
          multiple
          accept="video/mp4"
          @change="uploadVideo"
          style="display: none"
          ref="fileInputVideo"
        /> -->

        <div class="row my-2">
          <div class="col-3" v-for="(image, key) in images" :key="key">
            <img id="preview" class="custom-preview" :ref="'image'" />
            <!-- {{ image.name }} -->
          </div>
        </div>

        <!-- Video upload code -->
        <!-- <div class="row my-2">
          <div class="col-3" v-for="(video, key) in videos" :key="key">
            <p>{{ video.name }} uploaded successfully</p>
          </div>
        </div> -->
        <div class="row">
          <div class="col-12">
            <div class="my-3 float-right">
              <span 
              class="post-block-image mr-3"
              style="cursor: pointer"
              @click="onPickFileVideo"
              v-if="mediaType === 'video'"
              >
                <img class="celebrate-icon" src="@/assets/feed_Gif.svg" /> Video
              </span>
              <span
                class="post-block-image ml-2"
                style="cursor: pointer"
                @click="onPickFile"
                v-if="mediaType === 'image'"
              >
                <img class="celebrate-icon" src="@/assets/feed_gallery.svg" />
                Photo/GIF
              </span>
            </div>
          </div>
        </div>
        <div class="popup-btns">
          <btn-grp>
            <popup-btn text="Cancel" type="secondary" @click="cancel" />
            <popup-btn text="Save" type="primary" @click="saveAnnouncement" />
          </btn-grp>
        </div>
      </div>
    </div>
    <!-- End Here -->

    <!-- Birthday and Anniversary Modal -->
    <div class="modal" v-if="showBdayMsg">
      <div class="modal-content-lg" ref="modalBox">
        <div class="close-icon">
          <img
            class="cross-icon"
            src="@/assets/group-6.svg"
            @click="closeBdayModal"
          />
        </div>
        <div class="text-center bday-title-h2">
          <h2>Birthday & Anniversaries</h2>
        </div>
        <div class="row mb-3">
          <div class="col-12">
            <div class="day-text">Today</div>
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <div class="bday-card text-center">
              <div>
                <img src="@/assets/user.svg" class="userImg" />
              </div>
              <div>
                <strong>Mohana Saho</strong>
              </div>
              <div>Today's her Birthday</div>
              <div class="send-wish">Send wish</div>
            </div>
          </div>
          <div class="col-4">
            <div class="bday-card text-center">
              <div>
                <img src="@/assets/user.svg" class="userImg" />
              </div>
              <div>
                <strong>Mohana Saho</strong>
              </div>
              <div>Today's her Birthday</div>
              <div class="send-wish">Send wish</div>
            </div>
          </div>
          <div class="col-4">
            <div class="bday-card text-center">
              <div>
                <img src="@/assets/user.svg" class="userImg" />
              </div>
              <div>
                <strong>Mohana Saho</strong>
              </div>
              <div>Today's her Birthday</div>
              <div class="send-wish">Send wish</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End here -->

    <!-- Post Modal -->
    <div class="modal" v-if="showPostDetail">
      <div class="modal-content-lg" ref="modalBox">
        <div class="close-icon">
          <img
            class="cross-icon"
            src="@/assets/group-6.svg"
            @click="closeBdayModal"
          />
        </div>
        <div class="container">
          <div class="row">
            <div class="col-12">
              <h2 class="post-name-h2">{{ postDetail.name }}</h2>
            </div>
          </div>
          <div class="row my-3">
            <div class="col-4">
              <span>{{ formatDate(postDetail.created_at) }}</span>
            </div>
            <div class="col-8">
              <div class="float-right">
                <!-- <span class="pin-text" style="cursor: pointer"
                  ><img class="mx-2" src="@/assets/feed_pin.svg" alt />Pin this
                  Post
                </span> -->
                <!-- <span class="pin-color-orange" style="cursor: pointer"
                  ><img class="mx-2" src="@/assets/feed_pin2.svg" alt />Unpin this
                  Post
                </span> -->
                <!-- <span class="mx-3 line"></span>
                <span class="manage-text mr-3" style="cursor: pointer"
                  ><img
                    class="mx-2 img-align"
                    src="@/assets/feed_back.svg"
                    alt
                  />Previous</span
                >
                <span class="manage-text ml-3" style="cursor: pointer"
                  >Next
                  <img class="mx-2 img-align" src="@/assets/feed_next.svg" alt
                /></span> -->
              </div>
            </div>
          </div>
          <div class="row my-3">
            <div class="col-12">
              <p>
                {{ postDetail.details }}
              </p>
              <div class="row">
                <div class="col-2"></div>
                <div class="text-center col-8 mt-5">
                  <v-carousel hide-delimiters show-arrows interval="6000" v-if="postDetail.fileType !== 'video/mp4' && postDetail.fileType !== null">
                    <v-carousel-item
                      v-for="(image, index) in postDetail.filePath"
                      :key="index"
                      :src="image"
                      reverse-transition="fade-transition"
                      transition="fade-transition"
                    ></v-carousel-item>
                  </v-carousel>
                  <div v-else>
                    <video v-for="(item, i) in postDetail.filePath" :key="i" width="100%" height="100%" controls autoplay>
                      <source :src="item" type="video/mp4" />
                      <source src="movie.ogg" type="video/ogg" />
                      Your browser does not support the video tag.
                    </video>
                  </div>
                </div>
                <div class="col-2"></div>
                <!-- <div
                  class="text-center col-3 mt-5"
                  v-for="(image, index) in postDetail.filePath"
                  :key="index"
                >
                  <img :src="image" alt />
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End here -->
  </div>
</template>


<script>
import { mapActions, mapGetters, mapState } from "vuex";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { SalaryComponentsConstants } from "../../../../../apis/constants";

export default {
  name: "AddExitEmployees",
  components: {},
  data() {
    return {
      editor: ClassicEditor,
      editorData: "<p>Content of the editor.</p>",
      editorConfig: {
        // The configuration of the editor.
        // plugins: [
        //   BoldPlugin,
        //   EssentialsPlugin,
        //   ItalicPlugin,
        //   LinkPlugin,
        //   ParagraphPlugin,
        // ],

        toolbar: [
          "heading",
          "|",
          "alignment:left",
          "alignment:center",
          "alignment:right",
          "alignment:adjust",
          "|",
          "bold",
          "italic",
          "blockQuote",
          "link",
          "|",
          "bulletedList",
          "numberedList",
          "imageUpload",
          "|",
          "undo",
          "redo",
        ],

        ckfinder: {
          //uploadUrl:
          //  "/admin/Upload/uploadImages?command=QuickUpload&type=Files&responseType=json",
          //Backend processing upload logic returns json data, including uploaded (option true/false) and url two fields
        },

        options: {
          resourceType: "Images",
        },
      },
      showConfirmationMsg: false,
      showBdayMsg: false,
      showPostDetail: false,
      url: null,
      images: [],
      postform: {
        annoucement: "",
        details: "",
      },
      files: new FormData(),
      postList: [],
      postDetail: null,
      videos:[],
      mediaType: null,
      employeeId: ""
    };
  },
  activated() {
    this.fetchAll();
    //this.addAnnouncements();
  },
  mounted() {
    this.fetchAll();
  },
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID",
    }),
    ...mapState({
      role: (state) => state.auth.role,
      employeesExitsData: (state) => state.dashboard.add_exit_employees.exits,
      employeesJoiningsData: (state) => state.payroll.joinings.joinings, //fetch all employees data
    }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    },
    ifHr() {
      return localStorage.getItem("userRole") == "HR" ? true : false;
    },
    ifEmployee() {
      return localStorage.getItem("userRole") == "EMPLOYEE" ? true : false;
    }
  },
  methods: {
    ...mapActions({
      act_fetchAll: "dashboard/overview/feed/fetchAll",
      act_create: "dashboard/overview/feed/create",
      //act_fetchJoinings: "payroll/joinings/fetchJoinings",
    }),
    async fetchAll() {
      try {
        let res = await this.act_fetchAll(this.le_id);
        //console.log("Res",res.data.user.employee_id);
        this.postList = res.data.payload;
        //let employee_id = res.data.payload[0].id;
        this.employeeId = res.data.user.employee_id;
        this.postList.reverse();
        if (res) {
          return res;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err.message;
      }
    },
    // async addAnnouncements() {
    //   try {
    //     let res = await this.act_create();
    //     //console.log("fetched joinings data", res);
    //     if (res) {
    //       return res;
    //     }
    //   } catch (err) {
    //     this.toast = true;
    //     this.errmsg = err.message;
    //   }
    // },
    async performAction() {
      // //console.log('joinings data', this.employeesJoiningsData)
      //console.log("inside");
      this.$root._data.isSaving = true;
      let obj = {
        le_id: "1580822c-764b-11e9-8f9e-2a86e4085a59", //change to this.le_id
        paygroupId: "0066bdd3-448a-47b2-9210-14b5fc451f25", //to be made dynamic after paygroup is selected
        empCN: this.empCN,
        empId: "f51436b9-a93e-48a5-b7f6-e74e242a3e8f",
        resignation: this.resignDate,
        lastWorkingDay: this.lwd,
        reasonForExit: this.reason,
        remarksForESI: this.esiRemarks,
        FFSType: this.processType,
        remarks: this.remarks,
      };
      await this.act_create(obj);
      //this.refresh();
      setTimeout(() => {
        this.$root._data.isSaving = false;
      }, 500);
    },

    // Feed methods
    addAnnouncement(type) {
      this.postform.annoucement = "";
      this.postform.details= "";
      this.videos = [];
      this.images = [];
      this.files = new FormData();
      this.mediaType = type;
      this.showConfirmationMsg = true;
    },

    cancel() {
      this.showConfirmationMsg = false;
    },

    bdayAnnavarsary() {
      //this.showBdayMsg = true;
    },

    closeBdayModal() {
      this.showBdayMsg = false;
      this.showPostDetail = false;
    },

    displayDetails(postDetail) {
      //console.log("Path", postDetail);
      this.postDetail = postDetail;
      this.showPostDetail = true;
    },

    // onFileChange(e) {
    //   const file = e.target.files[0];
    //   this.url = URL.createObjectURL(file);
    // },

    onPickFile() {
      this.$refs.fileInput.click();
    },

    uploadImage(e) {
      let vm = this;
      var selectedFiles = e.target.files;
      for (let i = 0; i < selectedFiles.length; i++) {
        this.images.push(selectedFiles[i]);
        this.files.append("file", selectedFiles[i]);
        this.files.append("fileType", selectedFiles[i].type);
      }

      for (let i = 0; i < this.images.length; i++) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.$refs.image[i].src = reader.result;

          //console.log(this.$refs.image[i].src);
        };

        reader.readAsDataURL(this.images[i]);
      }

      
    },

    // onPickFileVideo() {
    //   this.$refs.fileInputVideo.click();
    // },

    // uploadVideo(e) {
    //   let vm = this;
    //   var selectedFiles = e.target.files;
    //   for (let i = 0; i < selectedFiles.length; i++) {
    //     this.videos.push(selectedFiles[i]);
    //     this.files.append("files", selectedFiles[i]);
    //     this.files.append("fileType", selectedFiles[i].type);
    //   }

    //   for (let i = 0; i < this.videos.length; i++) {
    //     let reader = new FileReader();
    //     reader.onload = (e) => {
    //       this.$refs.video[i].src = reader.result;

    //       //console.log(this.$refs.video[i].src);
    //     };

    //     reader.readAsDataURL(this.videos[i]);
    //   }

      
    // },

    async saveAnnouncement() {
      this.files.append("le_id", this.le_id);

      this.files.append("details", this.postform.details);

      this.files.append("annoucement", this.postform.annoucement);

      let res = await this.act_create(this.files);

      if (res.data.status) {
        const data = [...this.postList];
        data.push(res.data.payload);
        this.postList = data;
        this.fetchAll();
        this.showConfirmationMsg = false;
      }
    },

    formatDate(date) {
      var myDate = new Date(date);
      var month = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ][myDate.getMonth()];
      var str = myDate.getDate() + " " + month + " " + myDate.getFullYear();

      var time = new Intl.DateTimeFormat("default", {
        hour12: true,
        hour: "numeric",
        minute: "numeric",
      }).format(myDate);

      return str + " " + time;
    },

    pinPost(index) {
      const element = this.postList[index];
      this.postList.splice(index, 1);
      this.postList.splice(0, 0, element);
    },

    goToITDeclaration(rec) {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/incometax/incometaxdeclarationdashboard`,
        query: { id: rec }
      });
    },

    // goToMyDocuments() {
    //   this.$router.push(`/dashboard/${
    //     this.$route.params.entity_index ? this.$route.params.entity_index : 0
    //     }/organisation/documents`
    //   );
    // },

    goToITProofSubmission(rec) {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/incometaxproofplan`,
        query: { id: rec }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/components/margins.scss"; //margins
@import "@/scss/_variables.scss";

// #preview {
//   display: flex;
//   justify-content: center;
//   align-items: center;
// }

// #preview img {
//   max-width: 100%;
//   max-height: 500px;
// }

//Here add css
span.digit-12 {
  width: 32px;
  height: 40px;
  margin: 0 24px 0 0;
  font-size: 33px;
  font-weight: 600;
  color: #34c0be;
}
.update-text {
  margin-top: 13px;
  position: absolute;
}

img.celebrate-icon {
  width: 25px;
  margin-right: 10px;
  transform: translate(0px, 6px);
}

.avatar img {
  border-radius: 50%;
  position: relative;
  left: -5px;
  margin-left: -25px;
  z-index: 1;
}

.avatars {
  direction: rtl; /* This is to get the stack with left on top */
  text-align: center; /* Now need to explitly align left */
  padding-left: 25px; /* Same value as the negative margin */
}

.manage-text {
  font-size: 1.1rem;
  font-weight: 500;
  color: #5d409f;
  //margin-left: 30px;
  width: 45%;
}

.icon-arrow {
  float: right;
  margin-right: 18px;
  transform: translate(0px, -18px);
}

.icon-arrow > img {
  height: 10px;
}

.img-post-user {
  width: 70px;
  margin-left: -12px;
}

.chatRect-2 {
  border-radius: 4px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  padding: 10px;
}

.post-question {
  background: #f3f3f3;
  padding: 15px;
  border-radius: 18px;
  margin-top: 12px;
  //cursor: pointer;
}

.post-block-image {
  background: #f3f3f3;
  padding: 10px 12px 9px 10px;
  border-radius: 20px;
  color: #7f66b2;
  font-weight: 500;
}

.post-user-name {
  padding: 10px 12px 9px 10px;
}

.close-icon {
  width: 100%;
  text-align: right;
}

.cross-icon {
  width: 15px;
  cursor: pointer;
}

.bday-title-h2 {
  width: 100%;
}

.userImg {
  width: 80px;
}

.send-wish {
  margin-top: 20px;
  font-size: 14px;
  font-weight: bold;
  color: #37c6c0;
}

.bday-card {
  border: 2px solid #eeeeee;
  border-radius: 5px;
  text-align: center;
  padding: 20px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.1);
}

.day-text {
  max-width: 200px;
  background: #e7e7e7;
  padding: 12px;
  border-radius: 10px;
  text-align: center;
  font-weight: 600;
}

span.pin-text {
  margin: 0 24px 0 0;
  font-size: 15px;
  font-weight: 600;
  color: #34c0be;
}

span.pin-color-orange {
  margin: 0 24px 0 0;
  font-size: 15px;
  font-weight: 600;
  color: #fe9f39;
}

img.mx-2.img-align {
  transform: translate(0px, 5px);
}

.headline {
  display: block;
  font-size: 16px;
  font-weight: 600;
  color: #5d409f;
}

.custom-textarea {
  width: 100%;
}

.custom-top-bar {
  height: 64px;
  transform: translate(-30px, -30px);
  border-radius: 12px 12px 0px 0px;
  display: flex;
  background-color: #ffffff;
  padding: 24px 0 0 32px;
}

.custom-line {
  width: 100%;
  border: solid 1px #efefef;
  margin: -26px 0px 12px 0px;
}

.custom-preview {
  width: 100%;
}

.post-time {
  color: #6e6e6e;
  font-size: 1rem;
}

img.pin-blue {
  // margin-left: 73%;
  float: right;
}

.post-name-block {
  text-transform: capitalize;
  cursor: pointer;
}

.post-name-h2 {
  text-transform: capitalize;
}
// End here

// Timeline css
// .v-timeline:before {
//   bottom: 0;
//   content: "";
//   height: 100%;
//   left: calc(16% - 1px);
//   position: absolute;
//   top: 0;
//   width: 2px;
// }
// .v-timeline-item--right .v-timeline-item__opposite {
//   margin-right: 96px;
//   text-align: left;
// }
// .v-timeline-item__dot--large {
//   height: 26px;
//   left: calc(17% - 22px);
//   width: 26px;
// }
// .v-timeline-item__body {
//   position: relative;
//   height: 100%;
//   -webkit-box-flex: 1;
//   -ms-flex: 1 1 100%;
//   flex: 1 1 100%;
//   max-width: calc(80% - 48px);
// }
// .v-timeline-item__dot--large .v-timeline-item__inner-dot {
//   height: 16px;
//   margin: 5px;
//   width: 16px;
// }
// .v-timeline-item .v-card:after,
// .v-timeline-item .v-card:before {
//   content: "";
//   position: absolute;
//   border-top: 0px solid transparent;
//   border-bottom: 0px solid transparent;
//   border-right: 10px solid #000;
//   top: calc(50% - 10px);
// }

// End Here

// Modal css
.modal {
  display: block;
  position: fixed;
  z-index: 6;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  // background-color: rgba(0, 0, 0, 0.3);
  background: rgba(0, 0, 0, 0.6);
  -webkit-backdrop-filter: blur(14px);
  backdrop-filter: blur(10px);
}

.modal-content-lg {
  overflow-x: hidden;
  overflow-y: scroll;
  max-height: 550px;
  background-color: white;
  margin: 150px auto 0px auto;
  z-index: 20;
  width: 80%;
  // height: 191px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 12px;
  opacity: 0;
  padding: 30px 30px 30px 30px;
  -webkit-animation-name: showPopup;
  -webkit-animation-duration: 0.3s;
  -webkit-animation-delay: 0s;
  -webkit-animation-iteration-count: 1;
  // -webkit-animation-timing-function: ease-in-out;
  -webkit-animation-fill-mode: forwards;
}
/* Modal Content */

.modal-content {
  overflow-x: hidden;
  overflow-y: scroll;
  max-height: 550px;
  background-color: white;
  margin: 150px auto 0px auto;
  z-index: 20;
  width: 70%;
  // height: 191px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 12px;
  opacity: 0;
  padding: 30px 30px 30px 30px;
  -webkit-animation-name: showPopup;
  -webkit-animation-duration: 0.3s;
  -webkit-animation-delay: 0s;
  -webkit-animation-iteration-count: 1;
  // -webkit-animation-timing-function: ease-in-out;
  -webkit-animation-fill-mode: forwards;

  .success-icon {
    // margin-bottom: 40px;
  }

  .success-text {
    font-size: $font-size-l1;
    font-weight: 600;
    // margin-bottom: auto;
    margin-left: 12px;
    color: #6e6e6e;
  }

  .message-text {
    font-size: $font-size-l1;
    margin-bottom: 20px;
    line-height: 25px;
    animation-delay: 0.7s;
    animation-name: fadeInRight;
    -webkit-animation-name: fadeInRight;
  }
  .btn-confirm-delete {
    display: flex;
    align-items: center;
    *:nth-child(n) {
      margin-right: 20px;
    }
  }
  .warning {
    margin-bottom: 16px;
    text-align: center;
    height: 24px;
    width: 24px;
  }
  .btn-popup {
    display: block;
    border-radius: 4px;
    min-width: 150px;
    padding: 0px 10px;
    height: 35px;
    background-color: $color-primary;
    color: $color-white;
  }
  .btn-popup-secondary {
    display: block;
    border-radius: 4px;
    min-width: 150px;
    padding: 0px 10px;
    height: 35px;
    background-color: #ffffff;
    border: #34c0be solid 2px;
    color: #34c0be;
  }

  .close-btn {
    position: relative;
    transform: scale(2);
    left: 230px;
    bottom: 20px;
    cursor: pointer;
  }
}
.success-img {
  position: relative;
  height: 24px;
  width: 24px;
  &.animated {
    animation-name: pulse;
    animation-iteration-count: infinite;
    animation-duration: 3s;
    -webkit-animation-name: pulse;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-duration: 3s;
  }
}
.warn-img {
  position: relative;
  height: 24px;
  width: 24px;
}
.warning {
  display: flex;
  align-items: center;
  position: relative;
  white-space: nowrap;
  &.animated {
    animation-name: shake;
    animation-iteration-count: infinite;
    animation-duration: 3s;
    -webkit-animation-name: shake;
    -webkit-animation-iteration-count: infinite;
    -webkit-animation-duration: 3s;
  }
}
.warning-text {
  font-size: $font-size-l1;
  font-weight: 600;
  margin-left: 12px;
  color: #6e6e6e;
}
.circle {
  position: relative;
  animation-name: showc;
  animation-duration: 2s;
  opacity: 0;
  left: 10px;
  height: 80px;
  width: 80px;
  -webkit-animation-name: showc;
  -webkit-animation-duration: 0.3s;
  -webkit-animation-delay: 0.4s;
  -webkit-animation-iteration-count: 1;
  -webkit-animation-timing-function: ease-in-out;
  -webkit-animation-fill-mode: forwards;
}
.tick {
  position: absolute;
  bottom: 21px;
  left: 17px;
  width: 45px;
  height: 45px;
  opacity: 0;
  -webkit-animation-name: showt;
  -webkit-animation-duration: 0.3s;
  -webkit-animation-delay: 0.7s;
  -webkit-animation-iteration-count: 1;
  -webkit-animation-timing-function: ease-in-out;
  -webkit-animation-fill-mode: forwards;
}
@keyframes showPopup {
  0% {
    opacity: 1;
    transform: scale(0.2);
  }
  80% {
    transform: scale(1.1);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes showc {
  0% {
    opacity: 1;
    transform: scale(0.2);
  }
  80% {
    transform: scale(1.1);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes showt {
  0% {
    opacity: 1;
    transform: scale(0.2);
  }
  80% {
    transform: scale(1.1);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.img-msg-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
  animation-delay: 0.4s;
  animation-name: fadeInRight;
  -webkit-animation-name: fadeInRight;
}
@keyframes fadeInRight {
  0% {
    padding-left: 25px;
    opacity: 0;
  }
  100% {
    padding-left: 0px;
    opacity: 1;
  }
}
@-webkit-keyframes fadeInRight {
  0% {
    padding-left: 25px;
    opacity: 0;
  }
  100% {
    padding-left: 0px;
    opacity: 1;
  }
}
.popup-btns {
  margin-left: auto;
  &.animated {
    animation-name: fadeIn;
    animation-delay: 1s;
    animation-duration: 0.5s;
    -webkit-animation-name: fadeInRight;
    -webkit-animation-delay: 1s;
    -webkit-animation-duration: 0.5s;
  }
}
.animated {
  animation-duration: 0.3s;
  -webkit-animation-duration: 0.3s;
}

@keyframes pulse {
  0% {
    transform: scale3d(1, 1, 1);
  }
  5% {
    transform: scale3d(1.2, 1.2, 1.2);
  }
  10% {
    transform: scale3d(1, 1, 1);
  }
  100% {
    transform: scale3d(1, 1, 1);
  }
}
@-webkit-keyframes pulse {
  0% {
    transform: scale3d(1, 1, 1);
  }
  5% {
    transform: scale3d(1.2, 1.2, 1.2);
  }
  10% {
    transform: scale3d(1, 1, 1);
  }
  100% {
    transform: scale3d(1, 1, 1);
  }
}

@keyframes shake {
  1%,
  9% {
    transform: translate3d(-1px, 0, 0);
  }

  2%,
  8% {
    transform: translate3d(2px, 0, 0);
  }

  3%,
  5%,
  7% {
    transform: translate3d(-4px, 0, 0);
  }

  4%,
  6% {
    transform: translate3d(4px, 0, 0);
  }
  10% {
    transform: translate3d(0, 0, 0);
  }
  100% {
    transform: translate3d(0, 0, 0);
  }
}
@-webkit-keyframes shake {
  1%,
  9% {
    transform: translate3d(-1px, 0, 0);
  }

  2%,
  8% {
    transform: translate3d(2px, 0, 0);
  }

  3%,
  5%,
  7% {
    transform: translate3d(-4px, 0, 0);
  }

  4%,
  6% {
    transform: translate3d(4px, 0, 0);
  }
  10% {
    transform: translate3d(0, 0, 0);
  }
  100% {
    transform: translate3d(0, 0, 0);
  }
}
.top-bar {
  height: 64px;
  // width: 100%;
  width: 453px;
  transform: translate(-30px, -30px);
  border-radius: 12px 12px 0px 0px;
  display: flex;
  box-shadow: 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  background-color: #ffffff;
  padding: 24px 0 24px 32px;
}

.heading_new {
  font-size: 22px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #5d409f;
}

.badget-custom-popup-title {
  transform: translate(140px, -24px);
  width: 160px;
  height: 30px;
  padding: 5px 0px;
  border-radius: 14.5px;
  color: #5d409f;
  background-color: #ded4f3;
  text-align: center;
  font-weight: 600;
  line-height: 20px;
  display: inline-block;
  margin-right: 7px;
}

// End here

.notincluded {
  font-size: 30px;
}
.content {
  margin-left: 20px;
  margin-top: 15px;
}
.top {
  display: grid;
  grid-template-columns: 75% 25%;
}
.main-header {
  color: #6d6d6d;
  margin-top: 25px;
  font-size: 16px;
}
.myDayRect {
  width: 850px;
  height: 187px;
  border-radius: 4px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  .headerClass {
    padding: 18px 0 0 13px;
  }
}
.postFuncs {
  margin-left: 127px;
  img {
    margin-right: 45px;
  }
}
.chatRect {
  //width: 206px;
  // height: 856px;
  border-radius: 4px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  padding: 0px 20px 20px 20px;
  //margin-left: 22px;
}
.middle {
  display: flex;
}
.two {
  display: flex;
}
.myWidgetsRect {
  margin-top: 18px;
  width: 649px;
  height: 141px;
  border-radius: 4px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.1);
  background-color: #ffffff;

  .headerClass {
    padding: 15px 0 0 9px;
  }
}
.createPostRect {
  margin-top: -28px;
  width: 649px;
  height: 119px;
  border-radius: 4px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  padding: 49px 0 49px 56px;

  .post {
    display: flex;
    img {
      margin-top: -20px;
    }

    span {
      font-family: Montserrat;
      font-size: 14px;
      color: #34c0be;
      margin-left: 10px;
    }
  }
}
.attendanceRect {
  width: 426px;
  height: 187px;
  border-radius: 4px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  margin-left: 18px;
  margin-top: 18px;

  .headerClass {
    padding: 15px 0 0 9px;
  }
}
.birthdayRect {
  width: 426px;
  height: 154px;
  border-radius: 4px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  margin-left: 18px;
  margin-top: 18px;

  .headerClass {
    padding: 15px 0 0 9px;
    color: #9d9494;
    font-weight: 600;
  }
}
.line {
  width: 546px;
  height: 0px;
  border: solid 1px #efefef;
  //border: solid 1px #34c0be;
  margin-top: 19px;
}
.sortClass {
  margin-top: 13px;
  font-family: Montserrat;
  font-size: 12px;
  color: #646464;
  margin-left: 8px;
  width: 120px;
}
.posts {
  width: 649px;
  height: auto;
  border-radius: 4px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
}
.widget-class {
  display: flex;
  width: 649px;
  span {
    font-size: 14px;
    color: #646464;
    margin-left: 7px;
    margin-right: 52px;
    cursor: pointer;
  }
}
.alignRight {
}
.horSpace {
  margin-top: 20px;
}
.myTeamRect {
  width: 426px;
  height: 180px;
  border-radius: 4px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  margin-left: 18px;
  margin-top: 18px;

  .headerClass {
    padding: 15px 0 0 9px;
    color: #9d9494;
    font-weight: 600;
  }
}
.lrDetails {
  display: flex;
}
.lrClass {
  width: 43px;
  height: 33px;
  font-size: 33px;
  font-weight: 600;
  color: #34c0be;
  margin-left: 12px;
  margin-right: 3px;
}
.lrText {
  width: 146px;
  margin-bottom: 0px;
  height: 36px;
  font-size: 14px;
  color: #646464;
  margin-top: 0px;
}

.cursor-pointer-show {
  cursor: pointer;
}
</style>
